import { Link } from "react-router-dom";
import { LegalLayout, LegalSection } from "../components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service" updated="October 15, 2026" testId="terms-page">
      <LegalSection title="Agreement">
        <p>These terms govern your use of Ryan: the website at ryanremembers.com and the Ryan Chrome extension, operated by <strong>MERA Technology</strong>. By using Ryan you agree to these terms and to our <Link to="/privacy">Privacy Policy</Link>.</p>
      </LegalSection>

      <LegalSection title="Your account">
        <p>You sign in with Google and are responsible for activity on your account. You must be at least 13 years old, and old enough to form a binding contract where you live.</p>
      </LegalSection>

      <LegalSection title="Your content">
        <p>You own what you save. You give us a limited license to store, process and display it only to provide the service, including sending relevant content to our AI provider when you use Ask Ryan. You're responsible for making sure you have the right to save and share the content you pin.</p>
      </LegalSection>

      <LegalSection title="Acceptable use">
        <ul>
          <li>Don't use Ryan to break the law or infringe others' rights.</li>
          <li>Don't try to access other users' data, overload our systems, or reverse engineer the service.</li>
          <li>Don't use share links to distribute harmful or illegal content.</li>
        </ul>
        <p>We may suspend accounts that violate these rules.</p>
      </LegalSection>

      <LegalSection title="Plans, billing and limits">
        <ul>
          <li><strong>Free:</strong> 10 saves, 1 volume, and 5 Ask Ryan questions in total.</li>
          <li><strong>Signal:</strong> unlimited saves and volumes and 50 Ask Ryan questions per month.</li>
          <li><strong>Synthesis:</strong> billed per user, with 150 Ask Ryan questions per user per month pooled across the team workspace. Team members are covered while the owner's subscription is active.</li>
        </ul>
        <p>Monthly question limits reset on the 1st of each calendar month (UTC). Subscriptions renew automatically until cancelled. You can cancel anytime, and you'll keep access until the end of the paid period. Payments are processed by Stripe. Except where required by law, fees are non-refundable. We may change prices or limits with advance notice.</p>
      </LegalSection>

      <LegalSection title="AI answers">
        <p>Ask Ryan answers are generated by AI from your saved content and may be incomplete or wrong. Check important information before relying on it.</p>
      </LegalSection>

      <LegalSection title="Third-party services">
        <p>Ryan works with sites like Claude, ChatGPT and Gemini, and with services like Notion. We're not affiliated with them, and their own terms apply to your use of them.</p>
      </LegalSection>

      <LegalSection title="Disclaimers and liability">
        <p>Ryan is provided "as is", without warranties of any kind. To the fullest extent permitted by law, MERA Technology is not liable for indirect, incidental or consequential damages, or for lost data or profits. Our total liability is limited to the amount you paid us in the 12 months before the claim.</p>
      </LegalSection>

      <LegalSection title="Termination">
        <p>You can stop using Ryan and request account deletion at any time. We may suspend or end access for violations of these terms. Sections on content ownership, disclaimers, liability and governing law survive termination.</p>
      </LegalSection>

      <LegalSection title="Governing law">
        <p>These terms are governed by the laws of the State of Texas, USA, without regard to conflict-of-law rules. Disputes will be resolved in the state or federal courts located in Texas.</p>
      </LegalSection>

      <LegalSection title="Changes">
        <p>We may update these terms. If changes are material, we'll notify you, and continuing to use Ryan means you accept the updated terms.</p>
      </LegalSection>
    </LegalLayout>
  );
}
